'use client';

import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';
import {
    ensureOaiq,
    hasOpenAiAdsAttribution,
    OPENAI_ADS_PIXEL_DEBUG,
    OPENAI_ADS_PIXEL_ID,
    OPENAI_ADS_PIXEL_SDK_URL,
    setOpenAiAdsPixelActive
} from '@/lib/analytics/openai-ads-pixel';

/**
 * ChatGPT Ads Measurement Pixel – csak hirdetésből érkezőknél:
 * marketing hozzájárulás ÉS (oppref URL-paraméter VAGY __oppref süti) kell hozzá, különben a script le sem töltődik.
 * Hozzájárulás visszavonásakor oaiq("consent", false) leállítja a küldést és törli a __oppref/__obref cookie-kat.
 */
export default function OpenAiAdsPixel({ hasConsent }) {
    const [isActive, setIsActive] = useState(false);
    const isInitialized = useRef(false);

    useEffect(() => {
        if (!OPENAI_ADS_PIXEL_ID) return;

        if (!hasConsent) {
            try {
                if (isInitialized.current && typeof window.oaiq === 'function') window.oaiq('consent', false);
            } catch (_) {}
            setOpenAiAdsPixelActive(false);
            setIsActive(false);
            return;
        }

        if (!hasOpenAiAdsAttribution()) return;

        try {
            const oaiq = ensureOaiq();
            oaiq('consent', true);

            if (!isInitialized.current) {
                // Szándékosan nincs `user` objektum: személyes adatot nem adunk át
                oaiq('init', {
                    pixelId: OPENAI_ADS_PIXEL_ID,
                    ...(OPENAI_ADS_PIXEL_DEBUG ? { debug: true } : {})
                });
                isInitialized.current = true;
            }
        } catch (_) {
            return;
        }

        setOpenAiAdsPixelActive(true);
        setIsActive(true);
    }, [hasConsent]);

    if (!OPENAI_ADS_PIXEL_ID || !isActive) return null;

    return <Script id="openai-ads-pixel" src={OPENAI_ADS_PIXEL_SDK_URL} strategy="afterInteractive" />;
}
